/**
 * 营销管理api
 */
export default {
  // 会员管理
  memberInfopageList: "/memberInfo/pageList", // 会员列表
  memberInfobillPageList: "/memberInfo/billPageList", // 账单明细列表
  memberInfoselect_online_orders_info: "/memberInfo/select_online_orders_info", // 查询线上/线下订单详情
  memberInfomemberPurchasedPageList: "/memberInfo/memberPurchasedPageList", // 会员已购项目列表

  // 充值优惠
  rechargeDiscountdelete: "/rechargeDiscount/delete", // 删除充值优惠/{id}
  rechargeDiscountinsert: "/rechargeDiscount/insert", // 新增充值优惠
  rechargeDiscountselect: "/rechargeDiscount/select", // 查询充值优惠
  rechargeDiscountupdate: "/rechargeDiscount/update", // 修改充值优惠状态
  memberRechargeselect: "/memberRecharge/select", // 查询充值记录

  // 优惠券
  couponList: "/coupon/list", //  优惠券管理->优惠券列表
  couponSelectInfo: "/coupon/select_info", // 查询优惠券详情/{id}
  couponSave: "/coupon/save", // 新增优惠券
  couponUpdate: "/coupon/update", // 修改优惠券
  couponDelete: "/coupon/delete", // 删除优惠券/{id}
  couponselectCouponStore: "/coupon/selectCouponStore", // 查询优惠劵门店
  couponchooseStore: "/coupon/chooseStore", // 弹窗选择优惠劵门店
  couponaddStore: "/coupon/addStore", // 添加门店
  coupondeleteStore: "/coupon/deleteStore", // 删除门店

  couponRecordList: "/coupon/recordList", //  优惠券管理->领券列表
}
